import { createReducer } from 'utils/helpers';
import { CreditNotesActionTypes, IActions } from './CreditNotes.actions';

export interface IState {
    CreditNotesContext?: any;
    CreditNotesLookupPanelOpen?: boolean;
    CreditNote?: number;
    LineNumber?: number;
    SummaryPanelData?: any;
    IsChangeStatusDisabled: boolean;
    PreventChangeStatus: boolean;
    LHSFocusField: string;
    ComponentLineNumber?: number;
    ComponentId?: number;
    CreditNoteLineDetailSummary: any;
}

export const initialState: IState = {
    CreditNotesContext: {},
    CreditNotesLookupPanelOpen: true,
    CreditNote: undefined,
    LineNumber: 0,
    SummaryPanelData: undefined,
    IsChangeStatusDisabled: false,
    PreventChangeStatus: false,
    LHSFocusField: 'Invoice',
    ComponentLineNumber: 0,
    ComponentId: undefined,
    CreditNoteLineDetailSummary: null
};

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<CreditNotesActionTypes, IAction>;

const actionMap: IActionMap = {
    [CreditNotesActionTypes.setCreditNotesContext]: (state: IState, payload: IState['CreditNotesContext']): IState => ({ ...state, CreditNotesContext: payload }),
    [CreditNotesActionTypes.setCreditNote]: (state: IState, payload: IState['CreditNote']): IState => ({ ...state, CreditNote: payload }),
    [CreditNotesActionTypes.setLineNumber]: (state: IState, payload: IState['LineNumber']): IState => ({ ...state, LineNumber: payload }),
    [CreditNotesActionTypes.setSummaryPanelData]: (state: IState, payload: IState['SummaryPanelData']): IState => ({ ...state, SummaryPanelData: payload }),
    [CreditNotesActionTypes.setIsChangeStatusDisabled]: (state: IState, payload: IState['IsChangeStatusDisabled']): IState => ({ ...state, IsChangeStatusDisabled: payload }),
    [CreditNotesActionTypes.setPreventChangeStatus]: (state: IState, payload: IState['PreventChangeStatus']): IState => ({ ...state, PreventChangeStatus: payload }),
    [CreditNotesActionTypes.setCreditNotesLookupPanelOpen]: (state: IState, payload: IState['CreditNotesLookupPanelOpen']): IState => ({ ...state, CreditNotesLookupPanelOpen: payload }),
    [CreditNotesActionTypes.setLHSFocusField]: (state: IState, payload: IState['LHSFocusField']): IState => ({ ...state, LHSFocusField: payload }),
    [CreditNotesActionTypes.setComponentLineNumber]: (state: IState, payload: IState['ComponentLineNumber']): IState => ({ ...state, ComponentLineNumber: payload }),
    [CreditNotesActionTypes.setComponentId]: (state: IState, payload: IState['ComponentId']): IState => ({ ...state, ComponentId: payload }),
    [CreditNotesActionTypes.setCreditNoteLineDetailSummary]: (state: IState, payload: IState['CreditNoteLineDetailSummary']): IState => ({ ...state, CreditNoteLineDetailSummary: payload }),

};

export default createReducer<IActionMap, IState, IActions>(actionMap);
